/**
 * 老带新方案要求先服务、后推荐：按已知评分和未闭环问题提示下一步，
 * 但这里的表单也用于补录已发生的事实，提示不能阻止销售如实登记。
 */
import React from "react";

export default function PastCustomerGuidance({ customer, zh, referral = false }) {
  const score = customer.satisfactionScore == null ? null : Number(customer.satisfactionScore);
  const openIssues = Number(customer.openIssueCount) > 0;
  let message = "";
  if (openIssues) {
    message = zh ? "客户有未闭环问题，请先处理并确认闭环，暂不主动邀请评价、分享、拍摄或求推荐。" : "Resolve outstanding issues before actively requesting reviews, sharing, video or referrals.";
  } else if (score != null && score >= 1 && score <= 6) {
    message = zh ? "客户当前不满意，请先修复并确认满意，再主动邀请评价、分享、拍摄或求推荐。" : "Address the customer's concerns and confirm satisfaction before requesting reviews, sharing, video or referrals.";
  } else if (score === 7 || score === 8) {
    message = zh ? "客户基本满意：先处理问题，7 天后二次回访并确认满意，再主动求推荐。" : "Address concerns, follow up after 7 days and confirm satisfaction before requesting referrals.";
  } else if (score == null || !Number.isFinite(score) || score < 1 || score > 10) {
    message = zh ? "尚未记录满意度；请先回访确认，满意且问题闭环后再主动邀请评价、分享、拍摄或求推荐。" : "Confirm satisfaction and resolve any issues before requesting reviews, sharing, video or referrals.";
  }
  if (!message) return null;
  const recordNote = referral ? (zh ? "已发生的转介绍仍可如实登记。" : "Referrals already received may still be recorded.") : (zh ? "已发生的事项仍可如实登记。" : "Activities that already occurred may still be recorded.");
  return <p role="status" className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">{message} {recordNote}</p>;
}
